var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {
    staticClass: "plots",
    style: _vm.height,
    attrs: { id: _vm.element },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }